import React from "react";
import { Button, dialog, Modal } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import JobDetails from "./components/JobDetails";
import excludeFields from "./components/./ExcludeField";
import Table from "../../../components/Table";
import DialogDelete from "./components/DialogDelete";

import DialogCreateTitle from "./components/DialogCreateTitle";
import DialogCreate from "./components/DialogCreate";
import PositionTitlePresenter from "./PositionTitlePresenter";

class PositionTitlePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PositionTitlePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      showDetails: false,
      showFilters: false,
      empDetails: {},
      showModal: false,
      formData: {
        id: "",
        positionTitle: null,
        slotVacancy: 0,
        qualificationStandard: "",
        jobDescription: "",
        locations: [],
        location: "",
        deadline: "",
      },
      password: {},
    };
  }

  getCollectionName() {
    return "position_titles";
  }

  getToken() {
    return this.getParams().token;
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  handleSubmit = () => {
    this.presenter.handleSubmit(this.state.formData);
  };

  hideFilter() {
    this.setState({ showDetails: false });
  }

  onClickEdit() {
    const { empDetails } = this.state;
    this.presenter.onClickEdit(empDetails);
  }

  handleDelete() {
    const { empDetails } = this.state;
    this.presenter.onClickDelete(empDetails);
  }

  onSubmitPassword() {
    this.presenter.onSubmitPassword(this.state.password);
  }
  onChange(value, field) {
    this.setState((prevState) => ({
      password: {
        ...prevState.password,
        [field]: value,
      },
    }));
  }

  onClickAdd(object) {
    const schema = this.getSchemas();

    // const schemas = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const formData = this.state.formData;
    console.log("me", schemas);
    dialog.fire({
      html: (
        <DialogCreateTitle
          schema={schema}
          schemas={schemas}
          objects={object}
          onChangeData={this.onChangeObject.bind(this)}
          handleSubmit={this.handleSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onClickDelete() {
    const { empDetails } = this.state;
    dialog.fire({
      html: (
        <>
          <DialogDelete
            empDetails={empDetails}
            clickDelete={this.handleDelete.bind(this)}
            clickClose={() => dialog.close()}
          />
        </>
      ),
      footer: false,
    });
  }

  onclickView() {
    const { empDetails } = this.state;
    this.navigateTo(`/admin/job-details/view/${empDetails?.id}`);
  }

  getInitialFormData() {
    return {
      id: "",
      positionTitle: null,
      slotVacancy: 0,
      qualificationStandard: "",
      jobDescription: "",
      locations: [],
      location: "",
      deadline: "",
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  toggleAdd = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      formData: this.getInitialFormData(),
    }));
  };

  closeModal = () => {
    this.setState({ showModal: false });
    setTimeout(() => {
      this.forceUpdate(); // Ensure modal doesn't re-open immediately
    }, 100);
  };

  getAcl() {
    const user = this.getCurrentUser();
    return {
      // read: ["*", user.id],
      write: ["*", user.id],
    };
  }

  showFilter() {
    this.setState({ showFilters: true });
  }

  hideFilter() {
    this.setState({ showFilters: false });
  }

  clickData(object, index) {
    this.setState({ showFilters: true, showDetails: true, empDetails: object });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      formData,
      showFilters,
      showModal,
      showDetails,
    } = this.state;

    console.log("pos", objects);

    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">
                  {schema.label || this.getCollectionName()}
                </h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex ">
                {showFilters ? (
                  <div
                    className="d-flex flex-column me-2 w-50"
                    style={{
                      width: "50%",
                      position: "sticky",
                      top: 0,
                      alignSelf: "flex-start",
                      zIndex: 1,
                    }}
                  >
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          className="bi bi-arrow-left cursor-pointer me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      <label className="">Job Title</label>
                      <Search
                        schemas={this.getSchemas()}
                        className="mt-1"
                        onSubmit={this.searchSubmit.bind(this)}
                        fields={schema.fields}
                      />
                    </div>
                    {showDetails && empDetails && (
                      <div>
                        <JobDetails
                          object={empDetails}
                          clickView={this.onclickView.bind(this)}
                          clickEdit={this.onClickEdit.bind(this)}
                          clickDelete={this.onClickDelete.bind(this)}
                          isJobTitle={true}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (key) {
                          case "id":
                          case "deadline":
                          case "status":
                            acc.push(key);
                            break;
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        <div className="position-fixed bottom-0 end-0 m-4">
          <Button
            className="btn shadow-sm text-white"
            // onClick={this.onClickAdd.bind(this)}
            onClick={this.toggleAdd}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "25px",
              backgroundColor: "#e09552",
            }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div>
        <Modal isOpen={showModal} closable size="md">
          <Modal.Body>
            <DialogCreateTitle
              schema={schema}
              schemas={schemas}
              objects={formData}
              onChangeData={this.onChangeObject.bind(this)}
              handleSubmit={this.handleSubmit.bind(this)}
              handleClose={this.closeModal.bind(this)}
            />
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withRouter(PositionTitlePage);
